/* eslint-disable office-addins/load-object-before-read */
/* global localStorage */
import { createSlice, current } from "@reduxjs/toolkit";

const storeKey = "GRIDD_PREFERENCES";
const storedState = localStorage.getItem(storeKey);
// eslint-disable-next-line office-addins/call-sync-before-read
const parsedState = storedState?.length > 0 ? JSON.parse(storedState) : null;
if (parsedState) parsedState.changed = { ...parsedState };

function store(curr) {
  localStorage.setItem(
    storeKey,
    JSON.stringify({
      cellSwapStyles: curr.cellSwapStyles,
      advancedMenu: curr.advancedMenu,
      uiScale: curr.uiScale,
      userPrompt: curr.userPrompt,
      bubbleMenu: curr.bubbleMenu,
      autofitDebug: curr.autofitDebug,
      contextMenuDeltaX: curr.contextMenuDeltaX,
      contextMenuDeltaY: curr.contextMenuDeltaY,
    })
  );
}

export const preferencesSlice = createSlice({
  name: "preferences",
  initialState: parsedState ?? {
    cellSwapStyles: true,
    advancedMenu: false,
    uiScale: 1,
    bubbleMenu: false,
    autofitDebug: false,
    contextMenuDeltaX: 15,
    contextMenuDeltaY: 0,
    changed: {},
  },
  reducers: {
    update: (state, action) => {
      state.changed.cellSwapStyles = action.payload.cellSwapStyles ?? state.changed.cellSwapStyles;
      state.changed.advancedMenu = action.payload.advancedMenu ?? state.changed.advancedMenu;
      state.changed.uiScale = action.payload.uiScale ?? state.changed.uiScale;
      state.changed.userPrompt = action.payload.userPrompt === null ? null : action.payload.userPrompt;
      state.changed.bubbleMenu = action.payload.bubbleMenu ?? state.changed.bubbleMenu;
      state.changed.autofitDebug = action.payload.autofitDebug ?? state.changed.autofitDebug;
      state.changed.contextMenuDeltaX = action.payload.contextMenuDeltaX ?? state.changed.contextMenuDeltaX;
      state.changed.contextMenuDeltaY = action.payload.contextMenuDeltaY ?? state.changed.contextMenuDeltaY;
    },
    clearChanged: (state) => {
      state.changed = { ...state, changed: undefined };
    },
    apply: (state) => {
      state.cellSwapStyles = state.changed.cellSwapStyles ?? state.cellSwapStyles;
      state.advancedMenu = state.changed.advancedMenu ?? state.advancedMenu;
      state.uiScale = state.changed.uiScale ?? state.uiScale;
      state.userPrompt = state.changed.userPrompt === null ? null : (state.changed.userPrompt ?? state.userPrompt);
      state.bubbleMenu = state.changed.bubbleMenu ?? state.bubbleMenu;
      state.autofitDebug = state.changed.autofitDebug ?? state.autofitDebug;
      state.contextMenuDeltaX = state.changed.contextMenuDeltaX ?? state.contextMenuDeltaX;
      state.contextMenuDeltaY = state.changed.contextMenuDeltaY ?? state.contextMenuDeltaY;
      store(current(state));
    },
    reset: (state) => {
      state.cellSwapStyles = true;
      state.advancedMenu = false;
      state.uiScale = 1;
      state.userPrompt = null;
      state.bubbleMenu = false;
      state.autofitDebug = false;
      state.contextMenuDeltaX = 15;
      state.contextMenuDeltaY = 0;

      store(current(state));
    },
  },
});

export const { update, apply, reset, clearChanged } = preferencesSlice.actions;

export default preferencesSlice.reducer;
